<template>
  <div v-for="(arrayValue, arrayIndex) in dateArrayValue" :key="arrayIndex">
    <div>{{ arrayValue }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();

const dateArrayValue = computed(() => {
  const { cell } = props;
  const value = cell.meta?.('fullValue') ?? cell.value;
  return Array.isArray(value) ? value : [value];
});
</script>
